var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWalk = function SvgWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 44 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 37.1v-36C0 .93.842.064 1.899.01h17.037c2.683 0 2.013 1.973 2.013 1.973v11.945c0 .191-.599 5.417 2.151 5.172 1.016.92 4.389 0 5 0l.501.949c5.742.048 15.37.098 14.499 8.954V37.1c0 2.004.005 2-2 2h-40c-.205 0-1.1.004-1.1-2zm1.1 0h40v-9c.772-5.681-4.984-6.052-13-7-.757 0-3.076 1.092-5 0-1.781.422-3.223-1.187-5-4h-7v-2h7c.967.487 0-.574 0-2v-1h-7v-2h7v-3h-7v-2h7v-4h-17v36z"
  })));
};
export default SvgWalk;